import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import {
  MainContainer,
  MemberIcon,
  NoContentFound,
  ProjectDetailContainer,
} from "./styles";
import ProjectActions, { ProjectSelectors } from "Redux/ProjectRedux";
import React, { Component } from "react";

import { AuthenticationSelectors } from "Redux/AuthenticationRedux";
import Avatar from "Components/Avatar";
import BasicModal from "Modals/BasicModal";
import { Fonts } from "Themes";
import IconList from "Components/IconList";
import Image from "Components/Image";
import LoadingIcon from "Components/LoadingIcon";
import Orbiter from "./Orbiter";
import ProjectComments from "Components/ProjectComments";
import ProjectUpdate from "Components/ProjectUpdate";
import { connect } from "react-redux";
import navRoutes from "Navigation/NavRoutes";
import styled from "styled-components";

const ButtonContainer = styled.div`
  width: 100%;
  margin: auto;
  margin-top: 10px;
  display: flex;
`;

const ShowCommentsButton = styled.div`
  cursor: pointer;
  &: hover {
    opacity: 0.75;
  }
  font-family: ${Fonts.primaryFontFamily};
  flex: 1;
  padding: 0px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

class ExploreDetailContainer extends Component {
  state = {
    dataLoaded: false,
    contentType: "about",
    sendingComment: false,
    commentsLoaded: false,
    showLoginModal: false,
    showDescriptionModal: false,
    projectId: null,
    commentError: null,
    fetching: {
      projectUpdates: true,
      projectImages: true,
    },
    errors: {
      projectUpdates: null,
      projectImages: null,
    },
    showComments: false,
  };

  async componentDidMount() {
    const {
      getProjectDetails,
      getProjectResources,
      getProjectUpdates,
      getProjectImages,
      match: { params },
    } = this.props;

    const resolveProjectUpdates = {
      onSuccess: () =>
        this.setState((prevState) => ({
          fetching: { ...prevState.fetching, projectUpdates: false },
        })),
      onFailure: (e) =>
        this.setState((prevState) => ({
          fetching: { ...prevState.fetching, projectUpdates: false },
          errors: {
            ...prevState.errors,
            projectUpdates: "There was an error gettin the project updates",
          },
        })),
    };

    const resolveProjectImages = {
      onSuccess: () =>
        this.setState((prevState) => ({
          fetching: { ...prevState.fetching, projectImages: false },
        })),
      onFailure: (e) =>
        this.setState((prevState) => ({
          fetching: { ...prevState.fetching, projectImages: false },
          errors: {
            ...prevState.errors,
            projectImages: "There was an error",
          },
        })),
    };

    await getProjectDetails(params.slug);
    await getProjectResources(params.slug);
    await getProjectUpdates(params.slug, resolveProjectUpdates);
    await getProjectImages(params.slug, resolveProjectImages);

    this.setState({
      dataLoaded: true,
      projectId: params.slug,
    });
  }

  async componentDidUpdate(prevProps) {
    const { projectDetails, getComments } = this.props;
    if (prevProps.projectDetails !== projectDetails && projectDetails.id) {
      const data = projectDetails.id;
      const resolve = {
        onSuccess: () => this.handleCommentsSuccess(),
        onFailure: (e) => this.handleCommentsFailure(e),
      };

      await getComments(data, resolve);
    }
  }

  handleCommentsSuccess = () => {
    this.setState({
      commentsLoaded: true,
    });
  };

  handleCommentsFailure = (e) => {
    console.log("[ERROR]", e);
    this.setState({
      commentsLoaded: false,
    });
  };

  handlePostCommentSuccess = () => {
    this.setState({
      sendingComment: false,
      commentError: null,
    });
  };

  handlePostCommentFailure = (e) => {
    this.setState({
      sendingComment: false,
      commentError: e,
    });
  };

  handleSubmitComment = (values) => {
    const { isAuthenticated } = this.props;
    if (isAuthenticated) {
      this.setState({
        sendingComment: true,
      });

      const data = {
        id: this.props.projectDetails.id,
        comment: values.comment,
      };
      const resolve = {
        onSuccess: () => this.handlePostCommentSuccess(),
        onFailure: (e) => this.handlePostCommentFailure(e),
      };
      this.props.postComment(data, resolve);
    } else {
      this.setState({
        showLoginModal: true,
      });
    }
  };

  renderMembers = () => {
    const { projectMembers } = this.props;
    if (projectMembers.firstName) {
      return projectMembers.map(({ user }, key) => (
        <MemberIcon key={key}>{user.firstName[0]}</MemberIcon>
      ));
    }
    return;
  };

  handleJoinProject = async () => {
    const {
      joinProject,
      projectDetails: { id },
    } = this.props;
    await joinProject(id);
  };

  renderDescription = () => {
    const {
      projectDetails: { projectDescription },
    } = this.props;
    return projectDescription;
  };

  renderLinks = () => {
    const { projectResources } = this.props;
    return projectResources.map(({ resourceLink, resource }, key) => (
      <IconList
        key={key}
        image={resource.resourceImage}
        onClick={() => (window.location = resourceLink)}
      />
    ));
  };

  renderUpdates = () => {
    const { projectUpdates } = this.props;
    return <ProjectUpdate updates={projectUpdates} />;
  };

  renderImages = () => {
    const { projectImages } = this.props;
    const { fetching } = this.state;

    if (projectImages.length === 0) {
      return (
        <NoContentFound>This project doesn't have any media yet</NoContentFound>
      );
    }

    return (
      <div>
        {fetching.projectImages ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "15%",
            }}
          >
            <LoadingIcon />
          </div>
        ) : (
          <>
            {projectImages.map(({ image }, key) => (
              <Image source={image} key={key} />
            ))}
          </>
        )}
      </div>
    );
  };

  renderComments = () => {
    const { projectComments, history } = this.props;
    const { showComments } = this.state;
    if (projectComments.length === 0) {
      return;
    }

    return (
      <div>
        <ButtonContainer>
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div style={{ flex: 1, borderBottom: "solid 2px lightgray " }} />
            <div style={{ flex: 1 }} />
          </div>
          <ShowCommentsButton
            onClick={() =>
              this.setState((prevState) => ({
                showComments: !prevState.showComments,
              }))
            }
          >
            Show Comments ({projectComments.length}){" "}
            {showComments ? <IoIosArrowUp /> : <IoIosArrowDown />}
          </ShowCommentsButton>
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div style={{ flex: 1, borderBottom: "solid 2px lightgray " }} />
            <div style={{ flex: 1 }} />
          </div>{" "}
        </ButtonContainer>
        {showComments && (
          <ProjectComments comments={projectComments} history={history} />
        )}
      </div>
    );
  };

  renderProjectDetails = (details) => {
    let newDetails = details;
    if (details.length > 30) {
      newDetails = `${details
        .split("")
        .splice(0, 30)
        .join("")}...`;
    }
    return (
      <ProjectDetailContainer
        onClick={() =>
          this.setState({
            showDescriptionModal: true,
          })
        }
      >
        {newDetails}
      </ProjectDetailContainer>
    );
  };

  renderAvatar = () => {
    const { projectDetails, history } = this.props;

    if (!projectDetails.projectManager) return;

    return (
      <Avatar
        user={projectDetails.projectManager}
        text={projectDetails.projectManager.firstName}
        onClick={() =>
          history.push(
            `${navRoutes.profile}/${projectDetails.projectManager.id}`
          )
        }
      />
    );
  };

  renderImageModal = () => {
    const { showImageModal, selectedImage } = this.state;
    return (
      <BasicModal
        show={showImageModal}
        onHide={() => this.setState({ showImageModal: false })}
      >
        <img
          src={selectedImage}
          alt={"Not Found"}
          style={{ height: 300, borderRadius: 10 }}
        />
      </BasicModal>
    );
  };

  _navigateToUpdate = (id) => {
    const { projectDetails } = this.props;
    this.props.history.push(
      `${navRoutes.updateFeed}/${projectDetails.id}/${id}`
    );
  };

  render() {
    const { projectDetails, userDetails, history } = this.props;

    if (!projectDetails || !projectDetails.projectLinks) {
      return (
        <MainContainer
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <LoadingIcon />
        </MainContainer>
      );
    }

    return (
      <MainContainer>
        {this.renderImageModal()}
        <Orbiter
          history={history}
          projectDetails={projectDetails}
          user={userDetails}
          navigateToUpdate={this._navigateToUpdate}
          renderComments={this.renderComments()}
          handleSubmitComment={this.handleSubmitComment}
          sendingComment={this.state.sendingComment}
          commentError={this.state.commentError}
          onImageClick={(image) =>
            this.setState({
              showImageModal: true,
              selectedImage: image,
            })
          }
        />
        {/* <Masonry
          projectDetails={projectDetails}
          projectResources={projectDetails.projectLinks}
          projectImages={projectImages}
          projectUpdates={projectDetails.projectUpdates}
          renderAvatar={this.renderAvatar()}
          renderComments={this.renderComments()}
          sendingComment={this.state.sendingComment}
          handleSubmitComment={this.handleSubmitComment}
          commentError={this.state.commentError}
          onImageClick={(image) =>
            this.setState({
              showImageModal: true,
              selectedImage: image,
            })
          }
          projectColor={projectDetails.projectColor}
          navigateToUpdate={this._navigateToUpdate}
        /> */}
      </MainContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    projectDetails: ProjectSelectors.getProjectDetails(state),
    projectLeader: ProjectSelectors.getProjectLeader(state),
    projectMembers: ProjectSelectors.getProjectMembers(state),
    projectResources: ProjectSelectors.getProjectResources(state),
    userDetails: AuthenticationSelectors.getUserDetails(state),
    fetching: ProjectSelectors.getFetching(state),
    projectRequests: ProjectSelectors.getProjectRequests(state),
    projectComments: ProjectSelectors.getComments(state),
    isAuthenticated: AuthenticationSelectors.getAuthenticated(state),
    projectImages: ProjectSelectors.getProjectImages(state),
    projectUpdates: ProjectSelectors.getProjectUpdates(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getProjectDetails: (data) =>
      dispatch(ProjectActions.projectDetailRequest(data)),
    getProjectLeader: (data) =>
      dispatch(ProjectActions.projectLeaderRequest(data)),
    getProjectResources: (data) =>
      dispatch(ProjectActions.projectResourcesRequest(data)),
    getProjectMembers: (data) =>
      dispatch(ProjectActions.projectMembersRequest(data)),
    joinProject: (data) => dispatch(ProjectActions.joinProjectRequest(data)),
    postComment: (data, resolve) =>
      dispatch(ProjectActions.postCommentRequest(data, resolve)),
    getComments: (data, resolve) =>
      dispatch(ProjectActions.getCommentsRequest(data, resolve)),
    getProjectImages: (data, resolve) =>
      dispatch(ProjectActions.getProjectImagesRequest(data, resolve)),
    getProjectUpdates: (data, resolve) =>
      dispatch(ProjectActions.getProjectUpdatesRequest(data, resolve)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExploreDetailContainer);
